import PropTypes from 'prop-types'
import React from 'react'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'

const Z_INDEX = 1000

function Overlay (props) {
  return (
    <div
      onClick={props.onClick}
      style={{
        backgroundColor: props.backgroundColor,
        cursor: 'pointer',
        opacity: props.opacity,
        zIndex: props.zIndex,
        bottom: '0',
        left: '0',
        position: 'absolute',
        right: '0',
        top: '0',
        ...props.style
      }}
    />
  )
}

Overlay.BACKGROUND_COLOR = STYLES_COLOR
Overlay.propTypes = {
  overlay: PropTypes.string,
  backgroundColor: PropTypes.oneOf(
    Object.values(Overlay.BACKGROUND_COLOR)
  ),
  onClick: PropTypes.func,
  style: PropTypes.object,
  zIndex: PropTypes.number
}

Overlay.defaultProps = {
  backgroundColor: Overlay.BACKGROUND_COLOR.BLACK,
  opacity: '0.7',
  zIndex: Z_INDEX,
  style: {}
}

Overlay.Z_INDEX = Z_INDEX

export default Overlay
